<template>
  <div class="mind-map-wrapper">
    <div id="jsmind_container" ref="mindContainer"></div>

    <!-- 右侧知识点卡片 -->
    <div v-if="DialogVisible" class="knowledge-panel">
      <div class="panel-header">
        <span class="collapse-btn" @click="DialogVisible = false">收起</span>
      </div>

      <div class="panel-body">
        <div class="title">{{ selectedNodeTitle }}</div>
        <div v-if="knowledgeDialogVisible">
          <div class="tag">知识点</div>

          <div class="property-header">
            <div class="left">
              <i class="info-icon">i</i> 描述
            </div>
          </div>

          <div class="property-body" :class="{ expanded: isExpanded }" ref="contentBox">
            <div v-html="formatKnowledge(selectedKnowledge.join(''))"></div>
          </div>

          <div v-if="showToggle" class="toggle-btn" @click="toggleExpand">
            {{ isExpanded ? '收起内容' : '加载更多' }}
          </div>
        </div>
        <div  v-if="vrDialogVisible" class="vr-resource-list">
          <div class="property-header" style="width: 100%">
            <div class="left">
              <i class="info-icon fa fa-files-o"></i> VR资源
            </div>
          </div>
          <div class="property-body2" style="max-height: 80px;">
            <div
              v-for="(item, index) in selectedVRResources"
              :key="index"
              class="vr-resource-card"
              @click="handleVRResourceClick(item.appliId,item.title)"
            >
              <div class="vr-resource-title">{{ item.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 模态框 -->
    <div v-if="showVideo" class="modal-mask" @click.self="closeModal">
      <div class="modal-container">
        <div class="modal-header">
          <span class="modal-title">{{ currentVideoTitle }}</span>
          <div class="modal-actions">
            <button class="fullscreen-btn" @click="toggleFullscreen">
              <svg width="20" height="20" viewBox="0 0 24 24"><path d="M8 4H16V6H8V4ZM8 18H16V20H8V18ZM4 8V16H6V8H4ZM18 8V16H20V8H18Z" fill="currentColor"/></svg>
            </button>
            <button class="close-btn" @click.stop="closeModal">
              <svg width="20" height="20" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2"/></svg>
            </button>
          </div>
        </div>
        <div class="modal-content">
          <div v-if="modalLoading" class="modal-loading">
            <div class="spinner large"></div>
            <span>内容加载中...</span>
          </div>
          <iframe
            ref="modalIframe"
            :src="currentVideoSrc"
            frameborder="0"
            style="width: 100%; height: 100%"
            class="iframe-content"
            @load="handleModalLoad"
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import 'font-awesome/css/font-awesome.min.css'

  export default {
    name: "AbilityPage",
    data() {
      return {
        currentVideoSrc: '',
        modalLoading: true,
        currentVideoTitle: '',
        showVideo: false,
        jm: null,
        lessonId: 1,
        DialogVisible: false,
        knowledgeDialogVisible: false,
        selectedKnowledge: [],
        selectedVRResources: [],
        vrDialogVisible:false,
        selectedNodeTitle: '',
        isExpanded: false,
        showToggle: false,
        colorMap: {},
        colorList: ['#FFB6C1', '#87CEFA', '#FFD700', '#98FB98', '#FFA07A', '#9370DB']
      }
    },
    mounted() {
      this.loadMindMap();
    },
    watch: {
      knowledgeDialogVisible(val) {
        if (val) {
          this.$nextTick(() => {
            this.checkOverflow();
          });
        }
      }
    },
    methods: {
      handleVRResourceClick(path, title = '资源预览') {
        this.currentVideoSrc = "https://yq.keming365.com/webclient?appliId="+path;
        this.currentVideoTitle = title;
        this.modalLoading = true;
        this.showVideo = true;
      },
      handleModalLoad() {
        this.modalLoading = false;
      },
      closeModal() {
        this.showVideo = false;
        this.currentVideoSrc = '';
        this.currentVideoTitle = '';
      },
      toggleFullscreen() {
        const iframe = this.$refs.modalIframe;
        if (iframe.requestFullscreen) iframe.requestFullscreen();
        else if (iframe.webkitRequestFullscreen) iframe.webkitRequestFullscreen();
        else if (iframe.mozRequestFullScreen) iframe.mozRequestFullScreen();
        else if (iframe.msRequestFullscreen) iframe.msRequestFullscreen();
      },
      loadMindMap() {

        axios.get(`/api/lessons-atlas/${this.lessonId}`).then(res => {
          const mind = res.data;
          this.assignColorsAndData(mind.data, 1);

          const options = { container: 'jsmind_container', editable: false, theme: 'primary', view: { draggable: true }};
          this.jm = new window.jsMind(options);
          this.jm.show(mind);

          // 终极修复版监听器
          this.jm.add_event_listener((type, data) => {
            if (type === window.jsMind.event_type.select) {
              this.selectedVRResources =[]
              this.vrDialogVisible = false;
              const nodeId = String(data.node).trim();
              if (!nodeId || nodeId === 'undefined' || nodeId === 'null') {
                console.warn("非法 nodeId:", nodeId);
                return;
              }

              const node = this.jm.get_node(nodeId);
              if (!node) {
                console.warn("找不到 node:", nodeId);
                return;
              }

              if (node.data && node.data.nodeKnowledge && node.data.nodeKnowledge.length > 0) {
                this.selectedKnowledge = node.data.nodeKnowledge;
                this.selectedNodeTitle = node.topic;
                this.knowledgeDialogVisible = true;
                this.DialogVisible = true;
                this.isExpanded = false;
              }
              if(node.data && node.data.vrList && node.data.vrList.length > 0){
                this.selectedVRResources = node.data.vrList;
                this.selectedNodeTitle = node.topic;
                this.vrDialogVisible = true;
                this.DialogVisible = true;
              } else {
                const isExpanded = node.expanded;
                this.jm.expand_node(node, !isExpanded);
              }
            }
          });
        });
      },

      assignColorsAndData(node, depth) {
        // 终极统一 ID 处理，彻底防止 undefined
        node.id = (node.id ? String(node.id).trim() : `node_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`);

        if (!this.colorMap[depth]) {
          const colorIdx = (depth - 1) % this.colorList.length;
          this.colorMap[depth] = this.colorList[colorIdx];
        }
        node['background-color'] = this.colorMap[depth];
        node.data = { nodeKnowledge: node.nodeKnowledge || [],vrResources: node.vrlist || [] };
        if (depth > 1) node.expanded = false;
        if (node.children) node.children.forEach(child => this.assignColorsAndData(child, depth + 1));
      },

      formatKnowledge(rawText) {
        if (!rawText) return "";
        let formatted = "";
        // 修改正则：用捕获组保留句子结束符（。！？），并分割空格
        const sentences = rawText.split(/([。！？])\s*/);
        // 过滤空字符串并合并句子和结束符
        const validSentences = sentences.filter(s => s !== '');

        validSentences.forEach((sentence, index) => {
          // 奇数索引为结束符（如。！？），需要与前一个句子合并
          if (index % 2 === 1) {
            return; // 跳过单独的结束符（已合并到前一个句子）
          }
          // 合并句子和结束符（例如：句子内容 + 。）
          const fullSentence = index + 1 < validSentences.length
            ? sentence + validSentences[index + 1]
            : sentence;

          // 后续处理逻辑保持不变（使用合并后的完整句子）
          if (fullSentence.match(/[:：]/)) {
            const [title, content] = fullSentence.split(/[:：]/);
            formatted += `<h4>${title.trim()}</h4><p>${content.trim()}</p>`;
          } else if (fullSentence.match(/→|=/)) {
            formatted += `<div class="formula">${fullSentence.trim()}</div>`;
          } else {
            formatted += `<p>${fullSentence.trim()}</p>`;
          }
        });
        return formatted;
      },

      checkOverflow() {
        this.$nextTick(() => {
          const box = this.$refs.contentBox;
          if (box.scrollHeight > box.clientHeight) {
            this.showToggle = true;
          } else {
            this.showToggle = false;
          }
        });
      },

      toggleExpand() {
        this.isExpanded = !this.isExpanded;
        this.$nextTick(() => this.checkOverflow());
      }
    }
  }
</script>

<style scoped>
  .mind-map-wrapper {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    position: relative;
  }

  #jsmind_container {
    width: 100%;
    height: 100%;
    background-color: #f9f9fb;
    background-image: radial-gradient(circle, #dcdce1 1px, transparent 1px);
    background-size: 20px 20px;
    cursor: grab;
  }

  .knowledge-panel {
    position: absolute;
    top: 5%;
    right: 20px;
    width: 400px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.1);
    border: 1px solid #f0f0f0;
    z-index: 999;
    padding: 20px;
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
    max-height: 650px;
  }

  .panel-header {
    text-align: right;
    margin-bottom: 10px;
  }

  .collapse-btn {
    font-size: 14px;
    color: #666;
    cursor: pointer;
  }

  .panel-body .tag {
    display: inline-block;
    background: #FF8B66;
    color: #fff;
    font-size: 12px;
    padding: 4px 12px;
    border-radius: 999px;
    margin-bottom: 10px;
  }

  .panel-body .title {
    font-size: 22px;
    font-weight: bold;
    color: #1f1f1f;
    margin-bottom: 16px;
    line-height: 1.4;
  }

  .property-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .property-header .left {
    font-weight: bold;
    font-size: 16px;
    color: #333;
    display: flex;
    align-items: center;
  }

  .info-icon {
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #4F74FF;
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 18px;
    margin-right: 8px;
  }

  .property-body {
    background: #F4F4F4;
    border-radius: 12px;
    padding: 16px;
    font-size: 14px;
    color: #555;
    line-height: 1.8;
    overflow: hidden;
    max-height: 265px;
    transition: all 0.3s;
  }

  .property-body2 {
    background: #F4F4F4;
    border-radius: 12px;
    padding: 16px;
    font-size: 14px;
    color: #555;
    line-height: 1.8;
    overflow: hidden;
    max-height: 265px;
    transition: all 0.3s;
  }

  .property-body2:hover {
    overflow-y: auto;
  }

  .property-body.expanded {
    max-height: 350px;
    overflow-y: auto;
  }

  .property-body h4 {
    font-size: 16px;
    font-weight: bold;
    margin-top: 10px;
  }

  .property-body p {
    margin: 8px 0;
  }

  .formula {
    text-align: center;
    font-weight: bold;
    margin: 10px 0;
    color: #222;
  }

  .toggle-btn {
    text-align: center;
    color: #4F74FF;
    margin-top: 10px;
    cursor: pointer;
  }

  .vr-panel {
    position: absolute;
    top: calc(20% + 320px); /* 可根据实际调整与知识点面板的间距 */
    right: 20px;
    width: 400px;
    background: #fff;
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.1);
    border: 1px solid #f0f0f0;
    z-index: 999;
    padding: 20px;
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
    max-height: 600px;
  }
  .vr-resource-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .vr-resource-card {
    background: #f9f9fb;
    border-radius: 8px;
    padding: 10px;
    cursor: pointer;
    transition: all 0.3s;
  }
  .vr-resource-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  }
  .vr-cover {
    width: 100%;
    height: auto;
    border-radius: 4px;
    margin-bottom: 8px;
  }
  .vr-resource-title {
    font-size: 14px;
    color: #333;
  }

  /* 模态框相关样式 */
  .modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1001;
  }
  .modal-container {
    width: 95%;
    max-width: 1024px;
    background: white;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
  }
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    background: #1e293b;
    color: white;
  }
  .modal-title {
    font-size: 1.25rem;
    font-weight: 500;
  }
  .modal-actions {
    display: flex;
    gap: 12px;
  }
  .modal-actions button {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
  }
  .modal-actions button:hover {
    color: #ff4757;
  }
  .modal-content {
    height: 60vh;
    min-height: 400px;
    padding: 24px;
    background: #f8f9fa;
  }
  .modal-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .spinner.large {
    width: 40px;
    height: 40px;
    border: 4px solid #ccc;
    border-top-color: #1e90ff;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 10px;
  }
  @keyframes spin {
    to { transform: rotate(360deg); }
  }
</style>



// WEBPACK FOOTER //
// src/components/tp/AbilityPage.vue